/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesQuotePriceListResponseDto } from '../../models/sales-quote-price-list-response-dto';

export interface QuotePriceListsControllerRemove$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the quote price list to delete.
 */
  id: string;
}

export function quotePriceListsControllerRemove(http: HttpClient, rootUrl: string, params: QuotePriceListsControllerRemove$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuotePriceListResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, quotePriceListsControllerRemove.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesQuotePriceListResponseDto>;
    })
  );
}

quotePriceListsControllerRemove.PATH = '/o2-sales/quote-price-lists/{tenant}/{id}';
